import { adminInstance } from "src/dataProvider/axios";
import { ACCESS_TOKEN } from "src/utils/common";

export type UserSession = {
  id: string;
  userAgent: string;
  createdAt: string;
  lastActivityAt: string;
  expiresAt: string;
  revokedAt: string | null;
  current: boolean;
  active: boolean;
};

export const getUserSessions = () =>
  adminInstance.get<UserSession[]>("v1/auth/sessions");

export const revokeUserSession = (id: string) =>
  adminInstance.post(`v1/auth/sessions/${encodeURIComponent(id)}/revoke`);

export const recordUserActivity = () =>
  adminInstance.post("v1/auth/sessions/activity");

// Attempt server revocation; callers also clear the browser login if the network is unavailable.
export const signOut = () =>
  adminInstance
    .post("v1/auth/logout", undefined, {
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
      },
    })
    .then(
      () => true,
      () => false
    );
